import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { FAQ_LIST_REQUEST } from "containers/csboard/Action";
import { hideKeyboard } from "bridge/common/CommonBridge";

import { useSelector, useDispatch } from "react-redux";

import exclamation_light from "styles/common/img/mypage/exclamation_light.png";
import exclamation_dark from "styles/common/img/mypage/exclamation_dark.png";

import CustomSelectBox from "utils/CustomSelectBox";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    heading: {},
}));

const Faq_list = (props) => {
    const { user_id, mode, reloadState } = props;
    const classes = useStyles();
    const inputRef = useRef();

    const dispatch = useDispatch();
    const faqList = useSelector((state) => state.csboardReducer.faqList);

    const [textVal, setTextVal] = useState("");
    const [searchType, setSearchType] = useState("");
    const [list, setList] = useState();

    const faqLength = faqList.length;

    useEffect(() => {
        if (reloadState === "2") {
            dispatch(
                FAQ_LIST_REQUEST({
                    headerParam: user_id,
                    searchType: "",
                    keyword: "",
                }),
            );

            setSearchType("");
            setTextVal("");
        }
    }, [reloadState]);

    useEffect(() => {
        if (faqLength > 0) {
            faqList.map((ele) => {
                if (ele.FILE_PATH !== null) {
                    const split = ele.FILE_PATH.split("/");
                    ele.FILE_PATH = `http://down.wjthinkbig.com/${split[2]}/${split[3]}/${split[4]}/${split[5]}/${ele.FILE_NAME}`;
                }
            });
        }

        const faqArr = faqList.map((ele, i) => {
            return (
                <Accordion key={i}>
                    <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon className="cs-list-toggle-btn" />}
                    >
                        <div className="MuiTypography-root makeStyles-heading-2 MuiTypography-body1">
                            <ul>
                                <li>{ele.SEARCH_TYPE}</li>
                                <li className="cs-list-title">{ele.FAQ_TITE}</li>
                            </ul>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="MuiTypography-root makeStyles-heading-2 MuiTypography-body1">
                            <div dangerouslySetInnerHTML={{ __html: ele.FAQ_CNTT }}></div>
                            {/* <p>{makeLine(ele.FAQ_CNTT)}</p><br/> */}
                            {ele.FILE_PATH !== null && (
                                <div className="cs_img">
                                    <img src={ele.FILE_PATH} alt="" />
                                </div>
                            )}
                        </div>
                    </AccordionDetails>
                </Accordion>
            );
        });
        setList(faqArr);
    }, [faqList]);

    useEffect(() => {
        dispatch(
            FAQ_LIST_REQUEST({
                headerParam: user_id,
                searchType: "",
                keyword: "",
            }),
        );
    }, []);

    //셀렉트 옵션 기준 정렬
    useEffect(() => {
        dispatch(
            FAQ_LIST_REQUEST({
                headerParam: user_id,
                searchType: searchType,
                keyword: textVal,
            }),
        );
    }, [searchType]);

    //검색버튼 눌렀을 때
    const handleSearch = () => {
        dispatch(
            FAQ_LIST_REQUEST({
                headerParam: user_id,
                searchType: searchType,
                keyword: textVal,
            }),
        );
    };
    //엔터 눌렀을 때
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
            //inputRef.current.blur();
            hideKeyboard();
        }
    };

    const render = {
        searchResult: list,
        emptySearchResult: (
            <div className="no-file-wrap">
                <div className="no_file mark_position clear">
                    {mode ? (
                        <img src={exclamation_light} alt="경고" className="whiteMode-img" />
                    ) : (
                        <img src={exclamation_dark} alt="경고" className="darkMode-img" />
                    )}
                    검색 된 결과가 없습니다.
                </div>
            </div>
        ),
    };

    let currentValue;

    if (faqLength === 0) {
        currentValue = "emptySearchResult";
    } else {
        currentValue = "searchResult";
    }

    const optionItemList = [
        {
            itemName: "전체",
            value: "",
        },
        {
            itemName: "회원",
            value: "A",
        },
        {
            itemName: "학습",
            value: "B",
        },
        {
            itemName: "결제",
            value: "C",
        },
        {
            itemName: "이벤트",
            value: "D",
        },
        {
            itemName: "기타",
            value: "E",
        },
    ];

    return (
        <>
            <div className="NoticeList position-relative">
                <div className="undertab_tabs clear">
                    <div className="fl">
                        {/* 2022-02-17 19002004 커스템셀렉트박스 변경 */}
                        <div className="fl top_select1">
                            <CustomSelectBox
                                optionItemList={optionItemList}
                                clickEvent={setSearchType}
                                defaultType={"TOP"}
                            />
                        </div>
                        {/* <select
                            name=""
                            className="cs-select"
                            value={searchType}
                            onChange={(e) => {
                                setSearchType(e.currentTarget.value);
                            }}
                        >
                            <option value="" className="selcet_category">
                                전체
                            </option>
                            <option value="A" className="selcet_category">
                                회원
                            </option>
                            <option value="B" className="selcet_category">
                                학습
                            </option>
                            <option value="C" className="selcet_category">
                                결제
                            </option>
                            <option value="D" className="selcet_category">
                                이벤트
                            </option>
                            <option value="E" className="selcet_category">
                                기타
                            </option>
                        </select> */}
                    </div>
                    <div className="fr">
                        <div className="d_inb fl black-m-input">
                            <input
                                id="search_faq_keyWord"
                                type="text"
                                className="form-control"
                                placeholder="검색어를 입력해 주세요."
                                onChange={(e) => {
                                    setTextVal(e.currentTarget.value);
                                }}
                                onKeyPress={handleKeyPress}
                                ref={inputRef}
                                value={textVal}
                            />
                        </div>
                        <div className="fl ">
                            <button className="black-s-btn" onClick={handleSearch}>
                                검색
                            </button>
                        </div>
                    </div>
                </div>
                <div className="undertab_tab-bg">
                    <div className="">
                        <div className={classes.root}>{render[currentValue]}</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Faq_list;
